var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationBgGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_25_4967)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.3125C9.9375 7.3125 8.25 9 8.25 11.0625C8.25 13.5938 11.5312 16.4531 11.6719 16.5938C11.7656 16.6406 11.9062 16.6875 12 16.6875C12.0938 16.6875 12.2344 16.6406 12.3281 16.5938C12.4688 16.4531 15.75 13.5938 15.75 11.0625C15.75 9 14.0625 7.3125 12 7.3125ZM12 15.6094C11.0156 14.6719 9.1875 12.6562 9.1875 11.0625C9.1875 9.51562 10.4531 8.25 12 8.25C13.5469 8.25 14.8125 9.51562 14.8125 11.0625C14.8125 12.6094 12.9844 14.6719 12 15.6094ZM12 9.1875C10.9688 9.1875 10.125 10.0312 10.125 11.0625C10.125 12.0938 10.9688 12.9375 12 12.9375C13.0312 12.9375 13.875 12.0938 13.875 11.0625C13.875 10.0312 13.0312 9.1875 12 9.1875ZM12 12C11.4844 12 11.0625 11.5781 11.0625 11.0625C11.0625 10.5469 11.4844 10.125 12 10.125C12.5156 10.125 12.9375 10.5469 12.9375 11.0625C12.9375 11.5781 12.5156 12 12 12Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_4967",
    x1: 0,
    y1: 12,
    x2: 24,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54B27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186639"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBgGreen);
export default __webpack_public_path__ + "static/media/location_bg_green.14d5574a620a159b28efb3539df57e32.svg";
export { ForwardRef as ReactComponent };